import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import usePermissions from 'api/usePermissions';
import usePublisher from 'api/usePublisher';
import { useUserDetails } from 'api/useUserDetails';
import { Portal, Store } from 'common/contracts';
import { EPermissionGroup } from 'common/permissions.types';
import { permissionsUtil } from 'utils/permissionsUtil';

export const usePortalStoreInfo = () => {
  const { publisherId } = useParams();
  const { userDetails } = useUserDetails();
  const { getPermissions } = usePermissions();
  const { getPublisher } = usePublisher(publisherId);
  const permissions = getPermissions();

  const portalForStore = useMemo(() => {
    return userDetails?.portals?.find((portal: Portal) =>
      portal.stores?.some((store: Store) => store.storeId === publisherId)
    );
  }, [userDetails?.portals, publisherId]);

  const isPortalAssignedStore = !!portalForStore;
  const isParkingDomain = portalForStore?.isParkingDomain;
  const portalId = portalForStore?.portalId;
  const portalDashboardIntegrationUrl = portalId 
    ? `/portal/${portalId}/settings/integration` 
    : '';
  const portalDashboardEventsUrl = portalId 
    ? `/portal/${portalId}/settings/events` 
    : '';

  const hasIntegrationPermission = !permissionsUtil.shouldHideGroupInPermission(
    permissions,
    EPermissionGroup.INTEGRATION,
    getPublisher.data?._id
  );

  const isIntegrationsTabShown = hasIntegrationPermission && 
    (!isPortalAssignedStore || (isParkingDomain && isPortalAssignedStore));

  const isPageInactive = isPortalAssignedStore;

  return {
    isPortalAssignedStore,
    isParkingDomain,
    isIntegrationsTabShown,
    isPageInactive,
    portalDashboardIntegrationUrl,
    portalDashboardEventsUrl
  };
};

